import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ConversationList from "./ConversationList";
import ConversationView from "./ConversationView";
import NewChat from "./NewChat";
import { useChat } from "./chatStore";
import styles from "./chat.module.scss";

const useIsMobile = () => {
  const [mobile, setMobile] = useState(
    typeof window !== "undefined" ? window.matchMedia("(max-width: 767.98px)").matches : false
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767.98px)");
    const on = (e) => setMobile(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
};

// Mobil tam-ekran (app gibi) / desktop iki-pane kart. Tek kabuk; pane geçişi
// mobilde view state'inden, desktopta iki pane yan yana.
const ChatPanel = () => {
  const { open, view, expanded, activeConversation, closePanel, backToList } = useChat();
  const mobile = useIsMobile();

  // Mobil drawer/tam-ekran açıkken body scroll kilidi.
  useEffect(() => {
    if (!open) return undefined;
    if (mobile) document.body.classList.add("chat-fullscreen-open");
    const onKey = (e) => e.key === "Escape" && closePanel();
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.classList.remove("chat-fullscreen-open");
      document.removeEventListener("keydown", onKey);
    };
  }, [open, mobile, closePanel]);

  if (!open) return null;

  // ---- MOBİL: tek pane, tam ekran ----
  if (mobile) {
    let pane;
    if (view === "new") pane = <NewChat onBack={backToList} />;
    else if (view === "chat" && activeConversation)
      pane = <ConversationView conversation={activeConversation} mobile onBack={backToList} />;
    else pane = <ConversationList onClose={closePanel} />;

    return createPortal(
      <div className={`${styles.fullscreen}`} role="dialog" aria-modal="true">
        {pane}
      </div>,
      document.body
    );
  }

  // ---- DESKTOP: iki-pane kart (expanded → tam ekran) ----
  return createPortal(
    <div
      className={`${styles.overlay} ${expanded ? styles.overlayExpanded : ""}`}
      role="dialog"
      aria-modal="true"
    >
      <div className={styles.backdrop} onClick={closePanel} />
      <div className={`${styles.card} ${expanded ? styles.cardExpanded : ""}`}>
        <ConversationList onClose={closePanel} />
        <div className={styles.cardRight}>
          {view === "new" ? (
            <NewChat onBack={backToList} />
          ) : (
            <ConversationView conversation={activeConversation} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ChatPanel;
